<template>
  <div class="user-note">
    <div class="user-note__title">{{ title }}</div>
    <div class="user-note__desc">
      {{ comment }}
    </div>
    <div class="user-note__date">{{ formatDate(date) }}</div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  title: {
    type: String,
    default: null,
  },
  comment: {
    type: String,
    default: null,
  },
  date: {
    type: String,
    default: null,
  },
});

const formatDate = (date) => {
  const dateNew = new Date(date);

  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const formattedDate = dateNew.toLocaleString("en-US", options);
  return formattedDate;
};
</script>

<style lang="scss" scoped>
.user-note {
  &__title {
    color: var(--Color-Text-text-color-primary, #303133);
    font-size: 16px;
    font-weight: 800;
    line-height: 24px; /* 150% */
  }
  &__desc {
    color: var(--Color-Text-text-color-primary, #303133);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
  &__date {
    overflow: hidden;
    color: var(--Color-Text-text-color-secondary, #909399);
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
  }
}
</style>
